import script from "./CoreUiChatHistoryMessageReactionHistoryPopover.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoreUiChatHistoryMessageReactionHistoryPopover.vue?vue&type=script&lang=ts&setup=true"

import "./CoreUiChatHistoryMessageReactionHistoryPopover.vue?vue&type=style&index=0&id=87be904a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87be904a"]])

export default __exports__